import axiosClient from './base'

export const generateCustomToken = async () => axiosClient.get('/api/auth/generate-custom-token')
